import React from 'react';
import { services } from '../mock';
import * as LucideIcons from 'lucide-react';
import { Check } from 'lucide-react';

const Services = () => {
  return (
    <section id="services" className="py-24 bg-[hsl(var(--bg-light))]">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="mb-16 text-center">
          <span className="caption mb-4 block">
            What We Offer
          </span>
          <h2 className="heading-2 mb-6">
            Our Services
          </h2>
          <p className="body-medium max-w-3xl mx-auto">
            Comprehensive financial services tailored to meet your business needs
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service) => {
            const Icon = LucideIcons[service.icon];
            return (
              <div
                key={service.id}
                className="bg-white p-8 rounded-lg border border-[hsl(var(--border-light))] hover:border-[hsl(var(--primary-blue))] hover:shadow-xl hover:shadow-[hsl(var(--primary-blue))/.2] transition-all duration-300 group"
              >
                {/* Icon */}
                <div className="w-16 h-16 bg-[hsl(var(--primary-blue)/.1)] rounded-lg flex items-center justify-center mb-6 group-hover:bg-[hsl(var(--primary-blue)/.15)] transition-colors">
                  {Icon && <Icon className="text-[hsl(var(--primary-blue))]" size={32} />}
                </div>

                {/* Title & Description */}
                <h3 className="heading-4 mb-4">
                  {service.title}
                </h3>
                <p className="body-small mb-6 leading-relaxed">
                  {service.description}
                </p>

                {/* Features List */}
                <div className="space-y-3">
                  {service.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start gap-3">
                      <Check className="text-[hsl(var(--primary-blue))] flex-shrink-0 mt-0.5" size={18} />
                      <span className="body-small text-[hsl(var(--text-secondary))]">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
